import React, { memo, useEffect, useState } from 'react';
import { Snackbar, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";
import { onMessageListener } from "../../firebaseNotifications/firebase";
import { MocUserRole } from "../../core/services/models/Enums";

export const handleNotificationNavigation = (
  notificationObj: any,
  history: any,
  userRole: string
) => {
  if (
    Object.keys(notificationObj?.data)?.includes("appointmentId") &&
    Object.keys(notificationObj?.data)?.includes("patientId")
  ) {
    const { appointmentId, patientId } = notificationObj?.data
    history?.push(
      `/patientDiagnosis/${patientId}?appointmentId=${appointmentId}`
    )
  } else if (Object.keys(notificationObj?.data)?.includes("invoiceId")) {
    const { invoiceId } = notificationObj?.data
    const { discountApprovalId } = notificationObj?.data
    if (userRole !== MocUserRole?.FRONT_DESK) {
      history?.push(
        `/discountApprovalRequest/${discountApprovalId}/${invoiceId}`
      )
    }
  } else if (
    Object.keys(notificationObj?.data)?.includes("rmoApprovalId") &&
    Object.keys(notificationObj?.data)?.includes("patientId") &&
    Object.keys(notificationObj?.data)?.includes("recordId")
  ) {
    const { rmoApprovalId, patientId, recordId } = notificationObj?.data
    history.push({
      pathname: "/consultantApprovalRequest",
      state: {
        idValue: rmoApprovalId,
        patientIdValue: patientId,
        recordIdValue: recordId,
      },
    })
  } else if (Object.keys(notificationObj?.data)?.includes("patientId")) {
    if (
      notificationObj?.title ===
      "Patient Registration Confirmation to Front desk"
    ) {
      history?.push(`/patientList`)
    } else {
      const { patientId } = notificationObj?.data
      history?.push(`/invoices/${patientId}`)
    }
  } else if (notificationObj?.title === "Chemo Order Approval") {
    if (Object.keys(notificationObj?.data)?.includes("chemoOrderId")) {
      const { chemoOrderId } = notificationObj?.data
      history.push({
        pathname: "/chemoApprovalRequest",
        state: {
          id: chemoOrderId,
        },
      })
    }
  } else {
    history?.push(notificationObj?.data?.webType)
  }
};

const Notification = memo(() => {
  const history = useHistory()
  const [openNotify, setOpenNotify] = useState(true);
  const [notifications, setNotifications] = useState<any[]>([]);

  useEffect(() => {
    const handleMessage = async () => {
      try {
        const payload = await onMessageListener();
        if (payload) {
          setNotifications(prev => [...prev, payload]);
          setOpenNotify(true);
        }
      } catch (err) {
        console.error("Failed to handle notification:", err);
      }
    };
    const interval = setInterval(handleMessage, 1000);
    handleMessage();

    return () => {
      clearInterval(interval);
    };
  }, []);

  const action = (
    <IconButton
      size="small"
      aria-label="close"
      color="inherit"
      onClick={() => {
        setNotifications([]);
        setOpenNotify(false);
      }}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  );

  const handleClose = (index: number) => {
    setNotifications(prev => prev.filter((_, i) => i !== index));
  };

  const userRole = useSelector((state: any) => state?.user?.role)

  const handleNotificationClick = (notificationObj: any) => {
    handleNotificationNavigation(notificationObj, history, userRole);
  }

  return (
    <>
      {notifications.length > 0 && (
        <div>
          {notifications.map((each: any, index: number) => (
            <div
              key={`notification-${index}`}
              onClick={() => {
                handleNotificationClick(each)
              }}
              style={{ cursor: "pointer" }}
            >
              <Snackbar
                open={openNotify}
                autoHideDuration={10000}
                onClose={() => handleClose(index)}
                message={
                  <div>
                    <div style={{ textDecoration: "underline", marginBottom: "5px" }}>
                      {each?.notification?.title}
                    </div>
                    <div>{each?.notification?.body}</div>
                  </div>
                }
                action={action}
              />
            </div>
          ))}
        </div>
      )}
    </>
  );
});

export default Notification;